import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";

const CompanyMasterTable = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
      dispatch(updateNavbarHeading("Company Master"));
    }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [companyMaster, setCompanyMaster] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    Code: { text: "Code", visible: true },
    Name: { text: "Name", visible: true },
    ActiveFYFromDate: { text: "FY From Date",align:"center", visible: true },
    ActiveFYToDate: { text: "FY To Date",align:"center", visible: true },
    HRCalendarStartDate: { text: "Calendar Start Date",align:"center", visible: true },
  };

  const fetchCompanyMaster = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}company`);
      SetApiStatus(response?.status);      
      if (response.status === 200) {
        const companyData = response?.data?.data;
        setCompanyMaster(companyData);
      } else {
        console.error(
          "Failed to fetch Company Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Company Master", error);
    }
  };

  useEffect(() => {
    fetchCompanyMaster();
  }, []);

  const handleAdd = () => {
    navigate(`/company-master/add`)
  }

  const handleEdit = (id) =>{
    navigate(`/company-master/edit/${id.ID}`)
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={companyMaster}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon2={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isActionRequired={true}
              handleAddNew={handleAdd}
              handleIcon2={handleEdit}
              icons={{
                Icon2: <i className="fa fa-edit"></i>,
                Icon2Text: "Edit",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyMasterTable;
